/*
 * @Author: lidan
 * @Date: 2020-11-16 14:39:21
 * @LastEditTime: 2020-11-18 10:44:01
 * @LastEditors: lidan
 * @Description: 司机津贴汇总
 * @FilePath: \e6-module-settle-accounts-center\src\e6-module-settle-accounts-center\api\driverAllowanceSummary.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_FINANCIAL_WEB = ""
} = e6ModuleSettleAccountsCenterApi;

// 获取司机津贴汇总表格数据
export function queryPageTotal(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/queryPageTotal`,
    method: "post",
    data
  });
}

// 导出司机津贴汇总表
export function exportAllowanceTotal(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/exportTotal`,
    method: "post",
    data
  });
}
